// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wUvl","fullView":"styles_fullView__3wj6o"};